/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCaseRationale
 */
export interface InternalApiCaseRationale {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCaseRationale
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCaseRationale
     */
    textName: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiCaseRationale
     */
    archivedAt?: Date;
}

/**
 * Check if a given object implements the InternalApiCaseRationale interface.
 */
export function instanceOfInternalApiCaseRationale(value: object): value is InternalApiCaseRationale {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('textName' in value) || value['textName'] === undefined) return false;
    return true;
}

export function InternalApiCaseRationaleFromJSON(json: any): InternalApiCaseRationale {
    return InternalApiCaseRationaleFromJSONTyped(json, false);
}

export function InternalApiCaseRationaleFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCaseRationale {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'textName': json['textName'],
        'archivedAt': json['archivedAt'] == null ? undefined : (new Date(json['archivedAt'])),
    };
}

export function InternalApiCaseRationaleToJSON(json: any): InternalApiCaseRationale {
    return InternalApiCaseRationaleToJSONTyped(json, false);
}

export function InternalApiCaseRationaleToJSONTyped(value?: InternalApiCaseRationale | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'textName': value['textName'],
        'archivedAt': value['archivedAt'] == null ? value['archivedAt'] : value['archivedAt'].toISOString(),
    };
}

